// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1welb","header":"MergedInvoice_header__2Tr0t"};